if (window.innerWidth > 768) {
  console.log('hit!!! 768')
  let gridWrapper = document.querySelector('.new-you-may-also-like-mb #card-pdp-product-grid');
  const cardAtcBtn = () => {

    gridWrapper.querySelectorAll('.card-wrapper-box').forEach( (quickCartContainer) => {
      if (quickCartContainer.querySelector('.ethnc-qatc-btn-container')) {
        quickCartContainer.querySelector('.ethnc-qatc-btn-container').addEventListener('click', (evt) => {
          quickCartContainer.querySelector('.bt-qatc-container').addEventListener('click', (evt) => {
            if (evt.target.classList.contains('bt-qatc-container')) {
              quickCartContainer.querySelector('.bt-qatc-container').classList.remove('is-visible');
              quickCartContainer.querySelector('.bt-qatc-form-container').classList.remove ('is-visible');
            }
          });

          
          if (quickCartContainer.querySelector('.bt-qatc-form-variant-input[data-only-child]')) {
            console.log('hit !!!')
              const input = quickCartContainer.querySelector('.bt-qatc-form-variant-input[data-only-child]')
              fetch(`${routes.cart_url}.json`)
              .then( response => response.json())
              .then( cartData => {
                const cart = cartData;
                const totalCartPrice = cart.total_price / 100;
                const selectedPrice = parseFloat(input.dataset.price) /100;
                const variantQuantity = 1;
                const projectedTotalPrice = totalCartPrice + selectedPrice * variantQuantity;
                const itemInCart = cart.items.find((item) => item.variant_id === parseFloat(input.value));

                if (projectedTotalPrice > 250000) {
                  window.showAlert('You cannot exceed the maximum shopping limit of PKR 250,000');
                  return;
                }

                if (itemInCart && itemInCart.quantity >= 3) {
                  window.showAlert('Limit reached: Max 3 items per size can be added');
                  return;
                }

                atcFormApi(atcForm);
                atcForm.reset();
              })
              .catch(error => {
                console.error('Error fetching cart data:', error);
              });
          } else {
            quickCartContainer.querySelector('.bt-qatc-container').classList.add('is-visible');
            quickCartContainer.querySelector('.bt-qatc-form-container').classList.add('is-visible');
            const atcForm = quickCartContainer.querySelector('.bt-qatc-form');

              console.log('hittt else',atcForm);
              atcForm.addEventListener('input', (e) => {
                console.log('target',e)
              e.preventDefault();
              const input = e.target
              fetch(`${routes.cart_url}.json`)
              .then( response => response.json())
              .then( cartData => {
                const cart = cartData;
                const totalCartPrice = cart.total_price / 100;
                const selectedPrice = parseFloat(input.dataset.price) /100;
                const variantQuantity = 1;
                const projectedTotalPrice = totalCartPrice + selectedPrice * variantQuantity;
                const itemInCart = cart.items.find((item) => item.variant_id === parseFloat(input.value));

                if (projectedTotalPrice > 250000) {
                  window.showAlert('You cannot exceed the maximum shopping limit of PKR 250,000');
                  return;
                }

                if (itemInCart && itemInCart.quantity >= 3) {
                  window.showAlert('Limit reached: Max 3 items per size can be added');
                  return;
                }

                atcFormApi(atcForm);
                atcForm.reset();
                quickCartContainer.querySelector('.bt-qatc-container').classList.remove('is-visible');
                quickCartContainer.querySelector('.bt-qatc-form-container').classList.remove('is-visible');
              })
              .catch(error => {
                console.error('Error fetching cart data:', error);
              });
            });
          }

          
          if (quickCartContainer.querySelector('.ethnc-qatc-form-size-chart')) {
            quickCartContainer.querySelector('.ethnc-qatc-form-size-chart').addEventListener('click', evt => {
              console.log('evt', evt.target.dataset.scList)
              sizeguide(evt.target.dataset.scList);
              openDrawer('scMeasure');
              if (window.innerWidth < 749) {
                quickCartContainer.querySelector('.bt-qatc-container').classList.remove('is-visible');
                quickCartContainer.querySelector('.bt-qatc-form-container').classList.remove ('is-visible');
              }
            });
          }
        });
      }
    });
  }

  async function atcFormApi(form) {
    try {
      const cartSections = document.querySelector('cart-notification, cart-drawer');
      const formData = new FormData(form);
      if (cartSections) {
        formData.append('sections', Array.from(cartSections.getSectionsToRender(), section => section.id));
      }

      formData.append('sections_url', window.location.pathname)
      const resp = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!resp.ok) {
        throw new Error("Error While adding to cart")
      }

      const data = await resp.json();

      if (cartSections) {
        cartSections.renderContents(data);
      }
    } catch (error) {
      console.log("Quick add to cart error!!!", error)
    }
  }

  const variantListClose = () => {
    if (window.innerWidth > 768) {
      gridWrapper.querySelectorAll('.grid__item').forEach( productCard => {
        productCard.addEventListener('mouseleave', () => {
          if (productCard.querySelector('.bt-qatc-form-container')) {
            productCard.querySelector('.bt-qatc-form-container').classList.remove('is-visible');
          }
        });
      });
    }
  }

  const cardSlider = () => {
    console.log('init dk slider')
    let gridItems = gridWrapper.querySelectorAll('.grid__item');
    gridItems.forEach( item => {
      var swiper = new Swiper(item.querySelector('.card_carousel'), {
        loop: true
      });
    });
  }

  cardSlider();
  cardAtcBtn();
  variantListClose();
} else {
  let gridWrapper = document.querySelector('.new-you-may-also-like-dk #card-pdp-product-grid');
  const cardAtcBtn = () => {

    gridWrapper.querySelectorAll('.card-wrapper-box').forEach( (quickCartContainer) => {
      if (quickCartContainer.querySelector('.ethnc-qatc-btn-container')) {
        quickCartContainer.querySelector('.ethnc-qatc-btn-container').addEventListener('click', (evt) => {
          quickCartContainer.querySelector('.bt-qatc-container').addEventListener('click', (evt) => {
            if (evt.target.classList.contains('bt-qatc-container')) {
              quickCartContainer.querySelector('.bt-qatc-container').classList.remove('is-visible');
              quickCartContainer.querySelector('.bt-qatc-form-container').classList.remove ('is-visible');
            }
          });

          const atcForm = quickCartContainer.querySelector('.bt-qatc-form');
          if (quickCartContainer.querySelector('.bt-qatc-form-variant-input[data-only-child]')) {
            console.log('hit !!!')
              const input = quickCartContainer.querySelector('.bt-qatc-form-variant-input[data-only-child]')
              fetch(`${routes.cart_url}.json`)
              .then( response => response.json())
              .then( cartData => {
                const cart = cartData;
                const totalCartPrice = cart.total_price / 100;
                const selectedPrice = parseFloat(input.dataset.price) /100;
                const variantQuantity = 1;
                const projectedTotalPrice = totalCartPrice + selectedPrice * variantQuantity;
                const itemInCart = cart.items.find((item) => item.variant_id === parseFloat(input.value));

                if (projectedTotalPrice > 250000) {
                  window.showAlert('You cannot exceed the maximum shopping limit of PKR 250,000');
                  return;
                }

                if (itemInCart && itemInCart.quantity >= 3) {
                  window.showAlert('Limit reached: Max 3 items per size can be added');
                  return;
                }

                atcFormApi(atcForm);
                atcForm.reset();
              })
              .catch(error => {
                console.error('Error fetching cart data:', error);
              });
            } else {
              quickCartContainer.querySelector('.bt-qatc-container').classList.add('is-visible');
              quickCartContainer.querySelector('.bt-qatc-form-container').classList.add('is-visible');
              atcForm.addEventListener('input', (e) => {
              e.preventDefault();
              const input = e.target
              fetch(`${routes.cart_url}.json`)
              .then( response => response.json())
              .then( cartData => {
                const cart = cartData;
                const totalCartPrice = cart.total_price / 100;
                const selectedPrice = parseFloat(input.dataset.price) /100;
                const variantQuantity = 1;
                const projectedTotalPrice = totalCartPrice + selectedPrice * variantQuantity;
                const itemInCart = cart.items.find((item) => item.variant_id === parseFloat(input.value));

                if (projectedTotalPrice > 250000) {
                  window.showAlert('You cannot exceed the maximum shopping limit of PKR 250,000');
                  return;
                }

                if (itemInCart && itemInCart.quantity >= 3) {
                  window.showAlert('Limit reached: Max 3 items per size can be added');
                  return;
                }

                atcFormApi(atcForm);
                atcForm.reset();
                quickCartContainer.querySelector('.bt-qatc-container').classList.remove('is-visible');
                quickCartContainer.querySelector('.bt-qatc-form-container').classList.remove('is-visible');
              })
              .catch(error => {
                console.error('Error fetching cart data:', error);
              });
            });
          }
        });
      }
    });
  }

  async function atcFormApi(form) {
    try {
      const cartSections = document.querySelector('cart-notification, cart-drawer');
      const formData = new FormData(form);
      if (cartSections) {
        formData.append('sections', Array.from(cartSections.getSectionsToRender(), section => section.id));
      }

      formData.append('sections_url', window.location.pathname)
      const resp = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!resp.ok) {
        throw new Error("Error While adding to cart")
      }

      const data = await resp.json();

      if (cartSections) {
        cartSections.renderContents(data);
      }
    } catch (error) {
      console.log("Quick add to cart error!!!", error)
    }
  }

  const variantListClose = () => {
    if (window.innerWidth > 768) {
      gridWrapper.querySelectorAll('.grid__item').forEach( productCard => {
        productCard.addEventListener('mouseleave', () => {
          if (productCard.querySelector('.bt-qatc-form-container')) {
            productCard.querySelector('.bt-qatc-form-container').classList.remove('is-visible');
          }
        });
      });
    }
  }

  const cardSlider = () => {
    let gridItems = gridWrapper.querySelectorAll('.grid__item');
    gridItems.forEach( item => {
      var swiper = new Swiper(item.querySelector('.card_carousel'), {
        loop: true
      });
    });
  }

  cardSlider();
  cardAtcBtn();
  variantListClose();
}